import { axiosClient } from '@lib/axiosClient';

export interface SendNotificationPayload {
  recipientCpf: string;
  messageContent: string;
}

export async function sendNotification(payload: SendNotificationPayload, accessToken: string): Promise<void> {
  await axiosClient.post('/api/backend/v1/notification', payload, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
}
